import { selectHasMultiLocalCurrencies } from 'legacy/lut/features/partner360/configuration/selectors/selectHasMultiLocalCurrencies'
import { useCallback, useEffect } from 'react'
import { useSelector } from 'react-redux'

/** Applies the partner currency rule to both shared and locally controlled selectors. */
export const useCurrencyRestriction = (
  currency: string,
  onChangeCurrency: (currency: string) => void,
  isIgnoreMultiLocalCurrencies = false
) => {
  const hasMultiLocalCurrencies = useSelector(selectHasMultiLocalCurrencies)
  const isMultiLocalCurrencyLocked = !isIgnoreMultiLocalCurrencies && hasMultiLocalCurrencies

  useEffect(() => {
    if (isMultiLocalCurrencyLocked && currency !== 'USD') onChangeCurrency('USD')
  }, [currency, isMultiLocalCurrencyLocked, onChangeCurrency])

  const changeCurrency = useCallback(
    (value: string) => {
      if (!isMultiLocalCurrencyLocked) onChangeCurrency(value)
    },
    [isMultiLocalCurrencyLocked, onChangeCurrency]
  )

  return {
    currency: isMultiLocalCurrencyLocked ? 'USD' : currency,
    isMultiLocalCurrencyLocked,
    changeCurrency,
  }
}
